<template>
    <div id="wave" class="grey--text text--darken-4 grey lighten-3 rounded-xl px-4 pt-2 bubble-size ml-3">
        <span class="dot one" :style="`background-color: #212121`"></span>
        <span class="dot two" :style="`background-color: #212121`"></span>
        <span class="dot three" :style="`background-color: #212121`"></span>
    </div>
</template>

<script>
export default {
        props: {
            mainColor: {
                type: String,
                default: null
            }
        }
      }
</script>

<style scoped>
  #wave .dot {
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    margin-right: 2px;
    /* background: #00788f; */
    animation: wave 1s linear infinite;
    animation-delay: -0.9s;
  }
  #wave .dot.two {
    animation-delay: -0.7s;
  }
  #wave .dot:nth-child(3) {
    animation-delay: -0.6s;
  }
  @keyframes wave {
    0%,
    60%,
    100% {
        transform: initial;
    }
    30% {
        transform: translateY(-5px);
    }
  }
</style>

<style scoped src="../../../node_modules/vuetify/dist/vuetify.min.css">
</style>

<style scoped src="@mdi/font/css/materialdesignicons.css">
</style>